import React, { useMemo } from "react";
import ImageField from "components/common/atoms/ImageField";
import FilterSection from "./FilterSection";
import type { ContactListProps } from "../annotations/WhatsAppAnnotations";
import Icon from "../../../../static/images/UserIcon.svg";
import { FILE_URL } from "../../../../routes/ApiEndpoints";

const LeftPart: React.FC<ContactListProps> = ({
  data,
  onSelectUser,
  selectedUser,
  filterText,
  onInputFilterChange,
  onSelectFilterChange,
  onClearFilter,
}) => {
  // Filter and sort users using useMemo for optimization
  const filteredAndSortedUsers = useMemo(() => {
    if (!data?.users) {return [];}

    //Filter users based on search text
    const filtered = data.users.filter((user) =>
      user?.name?.toLowerCase()?.includes(filterText.name.toLowerCase())
    );

    //Sort users by lastmessagetime descending
    return filtered.sort((a, b) => {
      if (a.lastmessagetime && b.lastmessagetime) {
        return (
          new Date(b.lastmessagetime).getTime() -
          new Date(a.lastmessagetime).getTime()
        );
      }
      if (!a.lastmessagetime) {return 1;}
      if (!b.lastmessagetime) {return -1;}
      return 0;
    });
  }, [data?.users, filterText.name]);

  return (
    <div className="whatsapp-overview-left-part">
      {/* Filter section with office dropdowns and search input */}
      <FilterSection
        filterText={filterText}
        onSelectFilterChange={onSelectFilterChange}
        onInputFilterChange={onInputFilterChange}
        onClearFilter={onClearFilter}
        offices={data.offices}
      />

      {/* List of contacts */}
      <div className="chat-interface-left-section scrollBarDesign">
        {filteredAndSortedUsers.map((user, index) => (
          <div
            key={index}
            className={`chat-list-item cursor-pointer ${
              selectedUser?.to === user.to ? "active-chat" : ""
            } chat-users`}
            onClick={() => onSelectUser(user)}
          >
            <div className="d-flex align-items-center justify-content-between w-100">
              <div className="d-flex align-items-center">
                <div className="chat-users-icon">
                  <ImageField src={(user?.profilePicPath !== null && user?.profilePicPath !== '') ? `${FILE_URL}/${user.profilePicPath}` : Icon} className="whatsapp-profile" />
                </div>
                <span className="user-name ms-2">{user.name}</span>
              </div>
              {/* Show unread count if available */}
              {Number(user.unreadcount) > 0 && (
                <span className="chat-message-count">{user.unreadcount}</span>
              )}
            </div>
          </div>
        ))}
        {filteredAndSortedUsers.length === 0 && (
          <div className="text-center color-dark-pink marginTop2">
            No contacts found
          </div>
        )}
      </div>
    </div>
  );
};

export default LeftPart;
